import { useState, useEffect } from "react";
const EverlakeLoadingSpinner = ({
  loadingText = "Loading...",
  spinnerSize = "default",
  loadingTextMargin = "4",
}) => {
  const duration = 3500;
  const [dynamicSpinnerClass, setDynamicSpinnerClass] =
    useState(`mx-auto w-20`);

  useEffect(() => {
    switch (spinnerSize) {
      case "xs":
        // pixel 20
        setDynamicSpinnerClass(`mx-auto w-5`);
        break;
      case "sm":
        // pixel 40
        setDynamicSpinnerClass(`mx-auto w-10`);
        break;
      case "md":
        // pixel 64px
        setDynamicSpinnerClass(`mx-auto w-16`);
        break;
      default:
        setDynamicSpinnerClass(`mx-auto w-20`);
    }
  }, [spinnerSize]);

  return (
    <>
      <svg
        className={dynamicSpinnerClass}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 250.2 250.19"
        style={{
          WebkitAnimationName: "spin",
          WebkitAnimationDuration: `${duration}ms`,
          WebkitAnimationIterationCount: "infinite",
          WebkitAnimationTimingFunction: "linear",
          MozAnimationName: "spin",
          MozAnimationDuration: `${duration}ms`,
          MozAnimationIterationCount: "infinite",
          MozAnimationTimingFunction: "linear",
          msAnimationName: "spin",
          msAnimationDuration: `${duration}ms`,
          msAnimationIterationCount: "infinite",
          msAnimationTimingFunction: "linear",
          animationName: "spin",
          animationDuration: `${duration}ms`,
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
        }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <g id="Loading_3" data-name="Loading 3">
              <circle cx="125.1" cy="25.02" r="25.02" fill="#16446d" />
              <path
                fill="#d2daed"
                d="M72,36.62a25,25,0,1,1-35.39,0A25,25,0,0,1,72,36.62Z"
              />
              <path
                fill="#abbdde"
                d="M25,100.07a25,25,0,1,1-25,25A25,25,0,0,1,25,100.07Z"
              />
              <path
                fill="#87a4d0"
                d="M36.65,178.15a25,25,0,1,1,0,35.4A25,25,0,0,1,36.65,178.15Z"
              />
              <path
                fill="#648dc4"
                d="M100.08,225.16a25,25,0,1,1,25,25A25,25,0,0,1,100.08,225.16Z"
              />
              <path
                fill="#3a7bb9"
                d="M178.16,213.54a25,25,0,1,1,35.41,0A25.05,25.05,0,0,1,178.16,213.54Z"
              />
              <path
                fill="#57769f"
                d="M225.17,150.12a25,25,0,1,1,25-25.05A25,25,0,0,1,225.17,150.12Z"
              />
              <path
                fill="#5a6982"
                d="M213.55,72a25,25,0,1,1,0-35.39A25,25,0,0,1,213.55,72Z"
              />
            </g>
          </g>
        </g>
      </svg>
      <h3 className={`text-ui-blue-dark mt-${loadingTextMargin}`}>
        {" "}
        {loadingText}{" "}
      </h3>
    </>
  );
};

const EverlakeLoadingOverlayStyle = {
  overlay: (base) => ({
    ...base,
    background: "rgba(255, 255, 255, 0.8)",
    "z-index": "19",
  }),
};

export { EverlakeLoadingOverlayStyle, EverlakeLoadingSpinner };
